'use strict';

let _el;

const DashboardModalEl = {

    setElement(notificationEl) {
        _el = notificationEl;
    },

    openExistingSingleOrder(info) {
        _el.openExistingSingleOrder(
            info.orderSelected,
            info.dateRow,
            info.isFermenterTank,
            info.tankType,
            info.openGeneralTab,
            info.fermentingVolume,
            info.packagingVolume,
            info.totalBatchVolume,
            info.totalBatchVolumeMessageError,
            info.tankClicked,
            info.totalBatchCost
        );
    },

    openExistingBrewOrder(info) {
        _el.openExistingOrder(
            info.orderSelected,
            info.dateRow,
            info.isFermenterTank,
            info.tankType,
            info.openGeneralTab,
            info.fermentingVolume,
            info.packagingVolume,
            info.totalBatchVolume,
            info.totalBatchVolumeMessageError,
            info.tankClicked,
            info.totalBatchCost
        );
    },

    updateBatchVolumeAndLabel(totalFermenting, totalPackaging, order) {
        _el.updateBatchVolumeAndLabel(totalFermenting, totalPackaging, order);
    },

    updateVolumeLabels() {
        _el.updateVolumeLabels.apply(_el, arguments);
    },
    
    updateBatchCostLabel() {
        _el.updateBatchCostLabel.apply(_el, arguments);
    },

    openNewOrder() {
        _el.openNewOrder(...arguments);
    },

    disableToggles(callback) {
      _el.disableToggles(callback);
    },
    enableToggles(callback) {
      _el.enableToggles(callback);
    },

    close() {
        _el.close();
    }
};

module.exports = DashboardModalEl;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalEl.js
 **/